module.exports = __webpack_public_path__ + "static/media/img1-1.7368d52a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/N/img1-1.png
// module id = 1290
// module chunks = 3